const getUrl = ()=>{
    return 'https://chiran-tonmoy-api-v2.herokuapp.com';
}

export default getUrl;